'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var memsourceFriendly = function memsourceFriendly(locale) {
  return locale.replace('-', '_').toLowerCase();
};

exports.default = memsourceFriendly;
//# sourceMappingURL=memsourceFriendly.js.map
